import {useTranslation} from "ni18n";
import React, {useMemo} from "react";
import {getAllowedLocationsToRender} from "src/constants/locations";
import {useTypedSelector} from "src/store";

import Layout from "../../components/v5/Layout";
import LocationMapForLocations from "../../components/v5/LocationMapForLocations";
import {RegionSlug} from "../../store/types";
import {selectSelectedRegion} from "../../store/slices/userLocation";

type Props = {
  regionSlug: RegionSlug;
  state?: string;
  city?: string;
};

const LocationsIndex = ({regionSlug}: Props) => {
  const i18n = useTranslation();
  const locations = useTypedSelector(state => state.config.locations);
  const selectedRegionSlugFromStore = useTypedSelector(selectSelectedRegion) ?? "sf-bay-area";
  const renderableLocations = useMemo(() => getAllowedLocationsToRender(locations), [locations]);

  const pageTitle = i18n.t("Find a Carbon Health Urgent Care & Primary Care Provider Near You");
  const pageDescription = i18n.t(
    "Find an Adult or Pediatric Urgent Care or Primary Care provider near you. Book online for the fastest experience but walk-ins are always welcome.",
  );
  const selectedRegionSlug = useMemo(
    () => regionSlug || selectedRegionSlugFromStore,
    [regionSlug, selectedRegionSlugFromStore],
  );

  return (
    <Layout
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      pageImage="location-search"
      pageImageExt="gif"
      ogAlt={i18n.t("Find a Carbon Health location near you.")}
      navStartTransparent={false}
    >
      <LocationMapForLocations locations={renderableLocations} regionSlug={selectedRegionSlug} />
    </Layout>
  );
};

export default LocationsIndex;
